// extracted by mini-css-extract-plugin
export default {"rating":"kJ-z","numberOfStars":"lJ-z","count":"mJ-z","barGraphSpacing":"nJ-z","barGraph":"oJ-z"};